module.exports = __webpack_public_path__ + "static/img/guide_2.c69f800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/guide_2.jpg
// module id = rvUP
// module chunks = 1